module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 0 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 .2rem .2rem 0",
      "text-align": "right"
    }
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjSearchIndex'
      }),
      expression: "{name: 'QcxjSearchIndex'}"
    }]
  }, [_vm._v("切换至考级中心（点）")])], 1), _vm._v(" "), _c('van-search', {
    staticStyle: {
      "margin-bottom": ".2rem"
    },
    attrs: {
      "placeholder": "搜索俱乐部"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    staticClass: "qcxj-search-title"
  }, [_vm._v(_vm._s(_vm.params.keywords ? '搜索"' + _vm.params.keywords + '"结果' : '为您推荐：五星俱乐部'))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('van-cell', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ClubDetailUnbind',
          query: {
            id: item.id
          }
        }),
        expression: "{name: 'ClubDetailUnbind',query: {id: item.id}}"
      }],
      staticClass: "flex-start",
      attrs: {
        "value": item.danwei + item.clubleixing,
        "is-link": ""
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('img', {
            staticStyle: {
              "height": "1.2rem",
              "margin-right": ".3rem"
            },
            attrs: {
              "src": item.pic_url,
              "alt": ""
            }
          })]
        },
        proxy: true
      }], null, true)
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('van-cell', {
    staticClass: "qcxj-search-title"
  }, [_vm._v("公告")]), _vm._v(" "), _vm._l((_vm.noticeList), function(item, index) {
    return _c('van-cell', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name: 'NewsDetail', query:{id: item.id}}"
      }],
      staticClass: "flex-start",
      attrs: {
        "value": item.title,
        "is-link": ""
      }
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(!_vm.row.club.length) ? _c('van-button', {
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "size": "large",
      "round": ""
    }
  }, [_vm._v("您当前尚未绑定俱乐部")]) : _c('van-button', {
    staticStyle: {
      "width": "6rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "large",
      "round": ""
    },
    on: {
      "click": _vm.toCenter
    }
  }, [_vm._v("进入我的俱乐部")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "我的考级中心/点"
    },
    model: {
      value: (_vm.clubShow),
      callback: function($$v) {
        _vm.clubShow = $$v
      },
      expression: "clubShow"
    }
  }, [_c('van-cell-group', _vm._l((_vm.row.club), function(item, index) {
    return _c('van-cell', {
      attrs: {
        "title": item.danwei + item.clubleixing,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.toCheck(item.id)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18fd32a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubSearchIndex.vue
// module id = 1340
// module chunks = 0